import { render } from "./ThreadBit.vue?vue&type=template&id=061f6226"
import script from "./ThreadBit.vue?vue&type=script&lang=js"
export * from "./ThreadBit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__